import React from 'react'
import { Box, IconButton, TableCell, TableRow, Typography, useMediaQuery } from '@mui/material'
import EyeIcon from "../../common/assests/eyegreen.png";
import LockIcon from "../../common/assests/lockicons.png";
import DeletIcon from "../../common/assests/deleticon.png";
import BlockIcon from "../../common/assests/blockIcon.png";
import UserImg from '../../common/assests/sampleuser.svg'
import configuration from '../../config/Config';

const AllUserRow = ({row,handleViewMore,blockUser,resumeUser,deleteItem}) => {

  const isSmallScreen = useMediaQuery("(max-width:480px)")
  return (
    <TableRow key={row?._id}  sx={{ 
      "&:last-child td, &:last-child th": { border: 0 }, 
      
    }}>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src={row?.picture 
              ? `${configuration.cdnFront}/${row.picture}` 
              : UserImg}  
            alt={row?.fullname || 'User'}
            style={{
              height: "45px",
              width: "45px",
              marginRight: "8px",
              borderRadius: "50%",
            }}
          />
          <Typography>{row?.fullname || "-"}</Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1,whiteSpace:'nowrap' }}>{row?.bio || "-"}</TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>{row?.email || "-"}</TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1 }}>{row?.phone || "-"}</TableCell>
      <TableCell sx={{ opacity: row?.account_status === 3 ? 0.6 : 1,whiteSpace:'nowrap'}}>
      {
        row?.address 
          ? [
              row.address.address || "",
              // row.address.city || "",
              // row.address.state || "",
              // row.address.country || "",
              // row.address.zipcode || ""
            ]
            .filter(Boolean) 
            .join(", ")
          : "-"
      }
      </TableCell>
      <TableCell className="no-opacity"  sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
        <IconButton onClick={handleViewMore}>
          <img
            src={EyeIcon}
            alt="viewicon"
            style={{
              height: isSmallScreen ? "35px" : "42px",
              width: isSmallScreen ? "35px" : "45px",
            }}
          />
        </IconButton>
        <IconButton
         onClick={row?.account_status === 3 ? resumeUser : blockUser}>
            {row?.account_status === 3 ? (
              <img
                src={BlockIcon} 
                alt="unlockicon"
                style={{
                  height: isSmallScreen ? "35px" : "42px",
                  width: isSmallScreen ? "35px" : "45px",
                }}
              />
            ) : (
              <img
                src={LockIcon} 
                alt="lockicon"
                style={{
                  height: isSmallScreen ? "35px" : "42px",
                  width: isSmallScreen ? "35px" : "45px",
                }}
              />
            )}
          </IconButton>
        <IconButton onClick={deleteItem}>
          <img
            src={DeletIcon}
            alt="deleteicon"
            style={{
              height: isSmallScreen ? "35px" : "42px",
              width: isSmallScreen ? "35px" : "45px",
            }}
          />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}

export default AllUserRow